module.exports = __webpack_public_path__ + "media/vo-01-modal.abfa8acc.mp3";